import React from 'react';
import { ShoppingCart, X, Trash2, CreditCard, Shield } from 'lucide-react';
import { Button } from '../ui/button';

const CartWidget = ({ cart, removeFromCart, clearCart, onCheckout }) => {
  const total = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <aside className="fixed bottom-4 right-20 md:right-24 z-[60]" aria-label="Carrinho de compras">
      <div className="bg-slate-900/95 backdrop-blur-md border border-cyan-500/30 rounded-2xl shadow-2xl shadow-cyan-500/20 overflow-hidden w-72 md:w-80">
        <header className="bg-gradient-to-r from-cyan-600 to-blue-600 px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShoppingCart className="w-5 h-5 text-white" />
            <span className="text-white font-bold">Seu Pacote</span>
            <span className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full">{cart.length}</span>
          </div>
          <button onClick={clearCart} className="text-white/70 hover:text-white" aria-label="Limpar carrinho">
            <Trash2 className="w-4 h-4" />
          </button>
        </header>
        <ul className="p-4 max-h-48 overflow-y-auto">
          {cart.map(item => (
            <li key={item.id} className="flex items-center justify-between py-2 border-b border-slate-700/50 last:border-0">
              <div className="flex-1 min-w-0">
                <p className="text-white text-sm font-medium truncate">{item.name}</p>
                <p className="text-cyan-400 text-sm font-bold">R$ {item.price.toFixed(2).replace('.', ',')}</p>
              </div>
              <button onClick={() => removeFromCart(item.id)} className="text-gray-400 hover:text-red-400 p-1 ml-2" aria-label={`Remover ${item.name}`}>
                <X className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
        <footer className="p-4 bg-slate-800/50 border-t border-slate-700/50">
          <div className="flex items-center justify-between mb-3">
            <span className="text-gray-400">Total:</span>
            <span className="text-xl font-bold text-white">R$ {total.toFixed(2).replace('.', ',')}</span>
          </div>
          <Button onClick={onCheckout}
            className="w-full bg-gradient-to-r from-[#009ee3] to-[#00b1ea] hover:from-[#008ed0] hover:to-[#00a0d5] text-white font-bold text-sm"
            data-testid="checkout-btn">
            <CreditCard className="w-4 h-4 mr-2" /> Finalizar Compra
          </Button>
          <p className="text-xs text-gray-500 text-center mt-2 flex items-center justify-center gap-1">
            <Shield className="w-3 h-3" /> Pagamento seguro via Stripe
          </p>
        </footer>
      </div>
    </aside>
  );
};

export default CartWidget;
